'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _config = require('./config');

var config = _interopRequireWildcard(_config);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _async = function () {
  try {
    if (isNaN.apply(null, {})) {
      return function (f) {
        return function () {
          try {
            return Promise.resolve(f.apply(this, arguments));
          } catch (e) {
            return Promise.reject(e);
          }
        };
      };
    }
  } catch (e) {}return function (f) {
    // Pre-ES5.1 JavaScript runtimes don't accept array-likes in Function.apply
    return function () {
      var args = [];for (var i = 0; i < arguments.length; i++) {
        args[i] = arguments[i];
      }try {
        return Promise.resolve(f.apply(this, args));
      } catch (e) {
        return Promise.reject(e);
      }
    };
  };
}();function _awaitIgnored(value, direct) {
  if (!direct) {
    return Promise.resolve(value).then(_empty);
  }
}function _empty() {}

_bluebird2.default.config({
  cancellation: true
});

var calls = new Proxy(_extends({}, config), {
  get: function get(object, prop) {
    return object[prop] || function () {
      console.warn(prop + '() is not implemented or has not been loaded yet.');
      return Promise.reject(new Error('No method available for ' + prop + '.'));
    };
  }
});

var insertValuesIntoPath = function insertValuesIntoPath(values, path) {
  var names = Object.keys(values);
  names.forEach(function (name) {
    return path = path.replace(':' + name, '' + (values[name] || '').toString());
  });
  return path;
};

calls['init'] = _async(function (options) {
  var url = options.url,
      token = options.token,
      headers = options.headers;

  config.setAuthToken(token);
  /** First, fetch down the options. **/
  return _awaitIgnored(_bluebird2.default.resolve(fetch(url + '/endpoints', { method: 'get', headers: { 'Content-Type': 'application/json' } })).then(function (response) {
    return response.json();
  }).then(function (manifest) {
    var endpoints = Object.keys(manifest);

    var _loop = function _loop(endpoint) {
      var _endpoint$split = endpoint.split(' '),
          _endpoint$split2 = _slicedToArray(_endpoint$split, 2),
          method = _endpoint$split2[0],
          path = _endpoint$split2[1];

      calls[manifest[endpoint]] = function () {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var token = config.getAuthToken();
        return _bluebird2.default.resolve(fetch(url + '/' + insertValuesIntoPath(payload, path), {
          method: method.toLowerCase(),
          headers: _extends({
            token: token,
            'Content-Type': 'application/json'
          }, headers || {}),
          body: method !== 'GET' ? JSON.stringify(payload) : undefined
        })).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data.error) {
            var error = new Error(data.message);error.status = data.status;
            return _bluebird2.default.reject(error);
          }
          return _bluebird2.default.resolve(data);
        });
      };

      calls[manifest[endpoint]].url = url + '/' + path;
      calls[manifest[endpoint]].method = method;
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = endpoints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var endpoint = _step.value;

        _loop(endpoint);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }));
});

exports.default = calls;


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/index.js
// module id = 340
// module chunks = 0